import { mediaQuery } from 'constants/ui';

export const sectionWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const statusChipStyles = {
  fontWeight: 600,
  fontSize: '12px',
};

export const slotsWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const slotCardStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  border: ({ palette }) => `1px solid ${palette.divider}`,
  borderRadius: '8px',
};

export const slotInfoStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const locationWrapperStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '16px',

  [mediaQuery.mobile]: {
    gridTemplateColumns: '1fr',
  },
};

export const rejectWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  marginTop: '8px',
};

export const rejectActionsStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
};

export const headerRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
